var ne = Object.defineProperty;
var se = (t, e, s) => e in t ? ne(t, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[e] = s;
var T = (t, e, s) => se(t, typeof e != "symbol" ? e + "" : e, s);
import { reactive as G, computed as y, ref as re, onMounted as q, onUnmounted as k, defineComponent as $, createBlock as W, createCommentVNode as oe, openBlock as b, unref as _, withCtx as ae, createElementBlock as O, Fragment as H, renderList as Q, withModifiers as ce, normalizeClass as J, toDisplayString as j, createTextVNode as ie, watch as ue, withDirectives as le, vShow as de, createApp as ge } from "vue";
import fe from "@constructor-io/constructorio-client-javascript";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
import { CdrList as pe } from "@rei/cedar";
const he = (t, e = 300, s = 1e3) => {
  let n, r, c, f, l = 0;
  const u = () => {
    n && clearTimeout(n), r && clearTimeout(r), n = void 0, r = void 0;
  }, h = (p, i) => {
    u(), l = Date.now(), Promise.resolve(t.apply(f, c)).then(p).catch(i);
  };
  return function(...i) {
    c = i, f = this;
    const d = Date.now();
    l === 0 && (l = d);
    const S = d - l;
    return new Promise((I, w) => {
      if (S >= s) {
        h(I, w);
        return;
      }
      n && clearTimeout(n), n = setTimeout(() => h(I, w), e), r || (r = setTimeout(() => h(I, w), s - S));
    });
  };
}, L = /* @__PURE__ */ new Map();
let F = null;
const z = (t) => {
  var n, r;
  if (t === "" || !t) return {};
  const e = (n = window == null ? void 0 : window.document) == null ? void 0 : n.querySelector(t), s = (e == null ? void 0 : e.getAttribute("type")) === "application/json";
  if (!e || !(e instanceof HTMLScriptElement) && !s)
    return {};
  try {
    const c = JSON.parse((r = e.textContent) == null ? void 0 : r.trim());
    return F = c, typeof c != "object" || c === null || Array.isArray(c) ? (console.error(`Invalid JSON structure in script tag with ID: ${e.id}`), {}) : c;
  } catch (c) {
    return console.error(`Failed to parse JSON from script tag with ID: ${F == null ? void 0 : F.key}`, c), {};
  }
}, D = (t) => {
  if (L.has(t))
    return L.get(t);
  try {
    const e = document.querySelector(t);
    if (e instanceof HTMLElement)
      return L.set(t, e), e;
  } catch (e) {
    console.error(
      `Error finding DOM element with selector "${t}":`,
      e
    );
  }
  return L.set(t, null), null;
}, me = (t) => {
  const e = {};
  return Object.entries(t).forEach(([n, r]) => {
    e[n] = D(r);
  }), Object.values(e).every(
    (n) => n !== null
  ) ? !0 : (console.warn("Some elements failed to load:", e), !1);
}, P = (t) => L.get(t) || null, N = {
  SEARCH_INPUT: "[data-js=search-field]",
  SEARCH_FORM: "[data-js=search-form]",
  AUTOSUGGEST_WRAPPER: "[data-js=suggestion-box]",
  RECENT_SEARCH_BOX_WRAPPER: "[data-js=recent-search-box]"
}, ve = "#gnav-data", ye = "#ew-search-autosuggest", Se = {
  ENTER: "Enter",
  ESC: "Escape",
  ARROW_UP: "ArrowUp",
  ARROW_DOWN: "ArrowDown",
  ARROW_LEFT: "ArrowLeft",
  ARROW_RIGHT: "ArrowRight",
  HOME: "Home",
  END: "End"
}, Ie = "Search Suggestions", Ae = (t = ve) => {
  const {
    enableAutosuggest: e = !1,
    searchAction: s = "",
    useConstructorAutosuggest: n = !1
  } = z(t);
  return !!e && s === "/search" && !!n;
}, we = (t = ye) => {
  const {
    experienceName: e = "",
    variant: s = ""
  } = z(t);
  return e === "AutosuggestTest" && s === "variant1";
}, Ee = (t = {}) => {
  const {
    gnavDataJsonSelector: e,
    testConfigJsonSelector: s
  } = t;
  return Ae(e) && we(s) && me(N);
}, xe = (t) => {
  let e;
  if (t) {
    const s = ["gnavDataJsonSelector", "testConfigJsonSelector"];
    typeof t == "string" && t.length && (e = { [s[0]]: t }), typeof t == "object" && Object.keys(t || {}).some((n) => s.includes(n)) && (e = s.reduce((n, r) => (r in t && (n[r] = t[r]), n), {}));
  }
  return e;
}, R = class R {
  /**
   * Get the singleton instance of UserService
   */
  static getInstance() {
    return R.instance || (R.instance = new R()), R.instance;
  }
  /**
   * Gets the online account number from utag_data or by API call
   * @returns A promise that resolves to the online account number or null
   */
  static async getOnlineAccountNumber() {
    const e = window == null ? void 0 : window.utag_data, { isLoggedIn: s, onlineAccountNumber: n } = e || {};
    if (s === "logged in" && n)
      return n;
    if (!e) {
      const r = await R.fetchUser();
      return typeof (r == null ? void 0 : r.accountId) == "string" ? r.accountId : null;
    }
    return null;
  }
  /**
   * Fetches user data from the API
   * @returns A promise that resolves to user data or null
   */
  static async fetchUser() {
    try {
      const e = await fetch("/rest/user/account");
      return e.ok ? await e.json() : null;
    } catch {
      return null;
    }
  }
};
T(R, "instance");
let M = R;
const A = class A {
  constructor(e, s) {
    T(this, "apiKey");
    T(this, "serviceUrl");
    T(this, "baseConfig");
    T(this, "constructorIO");
    if (A.instance)
      throw new Error("Use AutoSuggestClient.getInstance() to access the singleton instance.");
    this.apiKey = e, this.serviceUrl = s, this.baseConfig = {
      resultsPerSection: {
        "Search Suggestions": 10
      }
    }, this.constructorIO = null, A.instance = this;
  }
  static getInstance(e, s) {
    return A.instance || (A.instance = new A(e, s)), A.instance;
  }
  async init() {
    if (!this.constructorIO) {
      const e = await M.getOnlineAccountNumber();
      this.constructorIO = new fe({
        apiKey: this.apiKey,
        serviceUrl: this.serviceUrl,
        userId: e || null
      });
    }
    return this.constructorIO;
  }
  async getAutosuggestResults(e, s = this.baseConfig) {
    return (await this.init()).autocomplete.getAutocompleteResults(e, s);
  }
};
T(A, "instance");
let U = A;
const be = U.getInstance(
  "key_9Mi6wJ14xYHiFlPx",
  "https://ezeubuswo-zone.cnstrc.com/"
), Re = async (t, e) => be.getAutosuggestResults(t, e), Te = he(Re, 70, 700), { SEARCH_INPUT: _e, RECENT_SEARCH_BOX_WRAPPER: B } = N, m = G({
  query: "",
  searchFieldIsFocused: !1,
  cleanQuery: y(() => m.query.trim()),
  isValidQuery: y(() => !!m.cleanQuery),
  suggestions: [],
  suggestionsLength: 0
});
function V(t = _e) {
  let e;
  const s = P(B) || D(B), n = (o) => {
    var a;
    e && ((a = e.parentElement) == null || a.setAttribute("aria-expanded", String(o)), e.setAttribute("aria-expanded", String(o)));
  }, r = re([]), c = y(
    () => r.value.map(
      (o) => {
        var a;
        return {
          key: (a = o.data.id) == null ? void 0 : a.trim().toLowerCase().replace(/\s+/g, "-"),
          term: o.value
        };
      }
    )
  ), f = async (o) => {
    var E;
    const v = await Te(o);
    r.value = ((E = v.sections) == null ? void 0 : E["Search Suggestions"]) || [], m.suggestionsLength = c.value.length, m.suggestions = c.value;
  }, l = async () => {
    m.query = e.value, m.searchFieldIsFocused = !0, m.isValidQuery && await f(m.query), setTimeout(() => {
      var a;
      const o = ((a = s == null ? void 0 : s.dataset) == null ? void 0 : a.visible) === "visible";
      (m.isValidQuery && m.searchFieldIsFocused && m.suggestionsLength > 0 || o) && n(!0);
    }, 0);
  }, u = () => {
    m.searchFieldIsFocused = !1, n(!1);
  };
  q(() => {
    e = P(t) || D(t), e == null || e.addEventListener("focus", l), e == null || e.addEventListener("blur", u);
  }), k(() => {
    e.removeEventListener("focus", l), e.removeEventListener("blur", u);
  });
  function h(o) {
    let a;
    q(() => {
      e && typeof o == "function" && (a = (v) => {
        const E = v.target;
        m.query = E.value, o(v);
      }, e.addEventListener("input", a));
    }), k(() => {
      e && e.removeEventListener("input", a);
    });
  }
  function p(o, a) {
    let v;
    q(() => {
      e && typeof o == "function" && (v = (E) => {
        o(E, a);
      }, e.addEventListener("keydown", v));
    }), k(() => {
      e && e.removeEventListener("keydown", v);
    });
  }
  function i(o) {
    e && (e.value = o, m.query = o);
  }
  function d() {
    e && e.focus();
  }
  function S() {
    e && e.blur();
  }
  function I(o) {
    e && o >= 0 ? e.setAttribute("aria-activedescendant", `autosuggest-result-${o}`) : e && e.setAttribute("aria-activedescendant", "");
  }
  function w(o, a) {
    if (e && o >= 0 && a) {
      i(a), e.setAttribute("aria-activedescendant", `autosuggest-result-${o}`);
      const v = new CustomEvent(
        "termSelected",
        {
          bubbles: !0,
          cancelable: !0
        }
      );
      e.dispatchEvent(v);
    }
  }
  return {
    searchInputState: m,
    getAutosuggestResultsAndSetSearchInputState: f,
    setAriaExpanded: n,
    updateInputFieldValue: i,
    updateAndSubmitSearchForm: w,
    focusOnInputField: d,
    blurOnInputField: S,
    setActiveDescendant: I,
    watchInputInputEvents: h,
    watchInputKeydownEvents: p
  };
}
const Oe = (t, e = {}) => ({
  handler: typeof e[t.key] == "function" ? e[t.key] : () => {
  }
}), g = G({
  activeIndex: -1
});
function X() {
  const {
    searchInputState: t,
    updateInputFieldValue: e,
    updateAndSubmitSearchForm: s,
    focusOnInputField: n,
    blurOnInputField: r,
    setActiveDescendant: c
  } = V(), {
    ENTER: f,
    ESC: l,
    ARROW_UP: u,
    ARROW_DOWN: h,
    ARROW_LEFT: p,
    ARROW_RIGHT: i,
    HOME: d,
    END: S
  } = Se, I = () => {
    var C;
    const x = (C = t.suggestions[g.activeIndex]) == null ? void 0 : C.term;
    s(g.activeIndex, x);
  }, w = () => {
    g.activeIndex = -1, e(""), r(), n();
  }, o = (x) => {
    x.preventDefault(), g.activeIndex <= 0 ? g.activeIndex = t.suggestionsLength - 1 : g.activeIndex -= 1;
  }, a = (x) => {
    x.preventDefault(), g.activeIndex < 0 && (g.activeIndex = -1), g.activeIndex >= t.suggestionsLength - 1 && (g.activeIndex = -1), g.activeIndex += 1;
  }, v = () => {
    g.activeIndex = -1;
  }, E = () => {
    g.activeIndex = -1;
  }, Y = () => {
    g.activeIndex = -1;
  }, Z = () => {
    g.activeIndex = -1;
  }, K = {
    [f]: I,
    [l]: w,
    [u]: o,
    [h]: a,
    [p]: v,
    [i]: E,
    [d]: Y,
    [S]: Z
  };
  return {
    listboxState: g,
    handleKeydown: (x, C = K) => {
      const { isValidQuery: ee, searchFieldIsFocused: te } = t;
      ee && te && (Oe(x, C).handler(x), c(g.activeIndex));
    },
    keydownHandlers: K
  };
}
const Le = ["id", "data-cnstrc-item-section", "data-cnstrc-item-name", "aria-selected", "onMouseover", "onMousedown"], Ce = /* @__PURE__ */ $({
  __name: "SearchListbox",
  props: {
    suggestions: {
      type: Array,
      required: !0
    },
    query: {
      type: String,
      default: ""
    },
    c9rSection: {
      type: String,
      required: !0
    },
    activeIndex: {
      type: Number,
      default: -1
    }
  },
  setup(t) {
    const e = t, {
      listboxState: s
    } = X(), {
      setActiveDescendant: n,
      updateAndSubmitSearchForm: r
    } = V(), c = y(() => {
      const {
        termParts: u
      } = e.suggestions[0];
      return Array.isArray(u) && u.length > 0;
    }), f = y(() => {
      const {
        activeIndex: u
      } = s;
      return u >= 0 ? u : e.activeIndex;
    }), l = (u) => {
      s.activeIndex = u, n(u);
    };
    return (u, h) => t.suggestions.length > 0 ? (b(), W(_(pe), {
      key: 0,
      id: "gnav-suggestion-list",
      "aria-label": "Search Suggestions",
      role: "listbox",
      class: "search-listbox",
      onMouseleave: h[0] || (h[0] = (p) => l(-1))
    }, {
      default: ae(() => [(b(!0), O(H, null, Q(t.suggestions, (p, i) => (b(), O("li", {
        id: `autosuggest-result-${i}`,
        key: p.key,
        "data-cnstrc-item-section": e.c9rSection,
        "data-cnstrc-item-name": p.term,
        role: "option",
        class: J(["search-listbox__list-item", {
          "search-listbox__list-item--active search-term": i === f.value
        }]),
        "aria-selected": i === f.value,
        onMouseover: (d) => l(i),
        onMousedown: ce((d) => _(r)(i, p.term), ["left"])
      }, [c.value ? (b(!0), O(H, {
        key: 0
      }, Q(p.termParts, (d) => (b(), O("span", {
        key: d.key,
        class: J({
          "search-listbox__list-item--query-text": d.queryText
        })
      }, j(d.text), 3))), 128)) : (b(), O(H, {
        key: 1
      }, [ie(j(p.term), 1)], 64))], 42, Le))), 128))]),
      _: 1
    })) : oe("", !0);
  }
}), Fe = (t, e) => {
  const s = t.__vccOpts || t;
  for (const [n, r] of e)
    s[n] = r;
  return s;
}, De = /* @__PURE__ */ Fe(Ce, [["__scopeId", "data-v-caf7291b"]]), Ne = /* @__PURE__ */ $({
  __name: "SearchAutosuggest",
  props: {
    suggestions: {
      type: Array,
      required: !0,
      validator(t) {
        return Array.isArray(t) && t.length <= 10;
      }
    },
    query: {
      type: String,
      required: !0
    },
    c9rSection: {
      type: String,
      required: !0
    },
    activeIndex: {
      type: Number,
      default: -1
    }
  },
  setup(t) {
    const e = t, s = y(() => e.suggestions.slice(0, 10)), n = y(() => e.query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")), r = y(() => new RegExp(`(\\b${n.value}\\b|${n.value})`, "gi")), c = y(() => s.value.map((f) => {
      const {
        term: l,
        key: u
      } = f;
      return {
        termParts: l.split(r.value).filter((i) => i !== "").map((i, d) => ({
          text: i.replace(/ /g, " "),
          queryText: i.toLowerCase() === n.value.toLowerCase(),
          key: `${u}-part-${d}`
        })),
        ...f
      };
    }));
    return (f, l) => (b(), W(De, {
      suggestions: c.value,
      query: e.query,
      "c9r-section": e.c9rSection,
      "active-index": e.activeIndex
    }, null, 8, ["suggestions", "query", "c9r-section", "active-index"]));
  }
}), qe = /* @__PURE__ */ $({
  __name: "SearchInputSuggestions",
  setup(t) {
    const {
      AUTOSUGGEST_WRAPPER: e
    } = N, s = D(e), {
      searchInputState: n,
      getAutosuggestResultsAndSetSearchInputState: r,
      focusOnInputField: c,
      blurOnInputField: f,
      watchInputInputEvents: l,
      watchInputKeydownEvents: u,
      setAriaExpanded: h
    } = V(), {
      handleKeydown: p,
      keydownHandlers: i,
      listboxState: d
    } = X(), S = y(() => n.isValidQuery && n.suggestionsLength > 0 && n.searchFieldIsFocused), I = y(() => S.value ? "autosuggest" : "none");
    return ue(S, () => {
      s.dataset.visible = S.value ? "visible" : "hidden";
    }), l(async () => {
      n.cleanQuery ? (d.activeIndex = -1, await r(n.query), n.suggestionsLength ? h(!0) : h(!1)) : (f(), c());
    }), u(p, i), (w, o) => {
      var a;
      return le((b(), W(Ne, {
        "c9r-section": _(Ie),
        suggestions: _(n).suggestions,
        query: _(n).cleanQuery,
        "active-index": (a = _(d)) == null ? void 0 : a.activeIndex,
        class: "search-input-suggestions"
      }, null, 8, ["c9r-section", "suggestions", "query", "active-index"])), [[de, I.value === "autosuggest"]]);
    };
  }
}), Ke = (t) => {
  if (Ee(xe(t))) {
    const { AUTOSUGGEST_WRAPPER: e } = N, s = P(e);
    try {
      ge(qe).mount(s);
    } catch (n) {
      console.error(n);
    }
  }
};
export {
  Ke as default
};
